
/**
 * Service class to operate on one cookie.
 */
class CookieService {

    // The name of the cookie to save if the consent was accepted
    static COOKIE_NAME_SETTINGS_COOKIE_CONSENT = 'settings.cookie-consent';

    // The name of the cookies that controls whether to display ads
    static COOKIE_NAME_SETTINGS_ADS_DISABLED = 'settings.ads-disable';

    static COOKIE_NAME_SETTINGS_PUSH = 'settings.push-notifications';
    static COOKIE_NAME_SETTINGS_PUSH_TOKEN_CREATED_AT = 'settings.push-notifications-token-created-at';

    constructor(name) {
        this.name = name;
    }

    /**
     * Prepares the statement to let a cookie expire in the specified amount of days.
     *
     * @param days
     */
    expiresInDays(days) {
        const d = new Date();
        d.setTime(d.getTime() + (days*24*60*60*1000));
        this.expiresString = `expires=${d.toUTCString()}`;

        return this;
    }

    /**
     * Prepares the statement to let the cookie belong to a specific path.
     *
     * @param path
     */
    path(path) {
        this.pathString = `path=${path}`

        return this;
    }

    /**
     * Prepares the statement to let the cookie belong to a specific domain.
     *
     * @param domain
     */
    domain(domain) {
        this.domainString = `domain=${domain}`

        return this;
    }

    /**
     * Sets the cookie with the specified value.
     *
     * @param value
     */
    set(value) {
        const cookieParts = [`${this.name}=${value}`];

        if (this.expiresString) {
            cookieParts.push(this.expiresString);
        }
        if (this.pathString) {
            cookieParts.push(this.pathString);
        }
        if (this.domainString) {
            cookieParts.push(this.domainString);
        }

        document.cookie = cookieParts.join('; ');
    }

    /**
     * Removes the cookie.
     */
    remove() {
        const cookieParts = [`${this.name}=`, 'expires=Thu, 01 Jan 1970 00:00:00 UTC'];

        if (this.pathString) {
            cookieParts.push(this.pathString);
        }
        if (this.domainString) {
            cookieParts.push(this.domainString);
        }

        document.cookie = cookieParts.join('; ');
    }

    /**
     * Gets the cookie value if any is set.
     *
     * @returns {string|null}
     */
    get() {
        let nameString = this.name + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(nameString) === 0) {
                return c.substring(nameString.length, c.length);
            }
        }

        return null;
    }
}

export default CookieService;